/** O evento que abre a folha "Trocar de conta" — a do app (`FolhaDeContas`) e a do navegador (`FolhaDeContasDoNavegador`); cada uma confere se é a sua. */
export const EVENTO_DA_FOLHA = 'contas:abrir';
